import React, { useRef, useMemo } from 'react';
import { Tooltip } from 'antd';

const TextWithTooltip = ({
  parentWidth,
  additionalTitle,
  mainTitle,
  render,
  ...props
}) => {
  const textRef = useRef();

  const needTooltip = useMemo(() => {
    if (textRef.current) {
      const textWidth = textRef.current?.getBoundingClientRect()?.width;
      return textWidth && parentWidth && textWidth >= parentWidth;
    }

    return false;
  }, [parentWidth, textRef.current]);

  const title = useMemo(() => {
    return [additionalTitle, needTooltip && mainTitle]
      .filter(Boolean)
      .join(' ');
  }, [additionalTitle, mainTitle, needTooltip]);

  return (
    <Tooltip
      placement="topLeft"
      title={title}
    >
      {render({ textRef, ...props })}
    </Tooltip>
  );
};

export default TextWithTooltip;
